import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'studentMsdNumberOnly',
    pure: false
})
export class StudentMsdNumberOnlyPipe implements PipeTransform {
    transform(mainArray: any[], msdNumber: string): any[] | undefined {
        if (!mainArray || !msdNumber) {
            if (!mainArray) {
                return [];
            } else {
                return mainArray;
            }
        }

        return mainArray.filter((item) => {
            if (item.STUDENT_IDENTIFIER_TYPES_ID === 4 || (item.STUDENT_IDENTIFIER_TYPES && item.STUDENT_IDENTIFIER_TYPES.ID === 4)) {
                return item.IDENTIFIER_VALUE === msdNumber;
            } else {
                return true;
            }
        });
    }
}
